import React, { useState, useEffect } from "react";
import { PhoneIcon } from "@heroicons/react/24/outline";
import image from "../../assets/images/image.png";
import CustomButton from "../sharedComponents/customButton";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
const AskSection = () => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();

  const handleClick = () => {
    navigateWithLang("/contact-us");
  };
  return (
    <div className="relative w-full h-[400px]" dir={direction}>
      {/* Image */}
      <img src={image} alt="intro" className="object-cover w-full h-full" />

      {/* Overlay Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center text-white bg-black bg-opacity-50">
        <h1 className="mb-4 text-3xl font-bold text-white">
          {t("askSection.haveQuestion")}
        </h1>
        <h1 className="mb-4 text-3xl font-bold text-white">
          {t("askSection.hereToHelp")}
        </h1>

        <button
          className="z-0 inline-flex items-center justify-center px-4 py-2 text-base font-medium text-black transition duration-300 ease-in-out transform bg-custom-yellow rounded-custom md:text-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap "
          dir="ltr"
          onClick={handleClick}
        >
          <PhoneIcon className="w-4 text-black me-2" />
          {t("askSection.contactUs")}
        </button>
      </div>
    </div>
  );
};

export default AskSection;
